import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { chartPalette, tooltipStyle } from '@/components/charts/chartTheme';

export interface DonutDatum { name: string; value: number; color?: string }

/** Themed donut chart with an inline legend. */
export function DonutChart({ data, height = 260, innerRadius = 60, outerRadius = 100 }: {
  data: DonutDatum[];
  height?: number;
  innerRadius?: number;
  outerRadius?: number;
}) {
  const colored = data.map((d, i) => ({ ...d, color: d.color ?? chartPalette[i % chartPalette.length] }));
  return (
    <div>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie data={colored} dataKey="value" nameKey="name" innerRadius={innerRadius} outerRadius={outerRadius} paddingAngle={2}>
            {colored.map((c, i) => <Cell key={i} fill={c.color} />)}
          </Pie>
          <Tooltip contentStyle={tooltipStyle} />
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-2 flex flex-wrap justify-center gap-4 text-xs text-fg-muted">
        {colored.map((c) => (
          <span key={c.name} className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: c.color }} />{c.name}</span>
        ))}
      </div>
    </div>
  );
}
